module.exports = __webpack_public_path__ + "static/media/pid_logo_primary_m.97be9b3b.png";